import React from "react";

const CareerContentCard = ({ heading, subHeading, body, link,responsiveStatus }) => {
  
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 16,
        padding: 20,
        boxShadow: "0 2px 12px #0001",
      }}
    >
      <h2
        style={{
          color: "#17252E",
          marginBottom: "8px",
          fontSize: "20px",
          lineHeight: "140%",
          fontWeight: '500',
        }}
      >
        {heading}
      </h2>
      <div style={{ width: "112px", height: "2px", background: "#1a6ed8" }} />

      <h1 style={{ fontWeight: 600, fontSize: responsiveStatus? 18 : 32, margin: "8px 0 24px 0" }}>
        {subHeading}
      </h1>
      <div
        style={{
          color: "#515050",
          fontWeight: 400,
          fontSize: 16,
          marginBottom: 32,
        }}
        dangerouslySetInnerHTML={{ __html: body }}
      />

      {link && (
        <a className="btn btn-primary-login"
          href={link.url}
          target="_blank"
          rel="noreferrer"
          style={{
            display: "inline-block",
            background: "#1a6ed8",
            color: "#fff",
            padding: "8px 32px",
            borderRadius: 6,
            textDecoration: "none",
            fontWeight: 500,
            fontSize: '14px',
            hover: {
              background: "#01224f",
              color: "#fff",
            }
          }}
        > 
                  {link.text}
        </a>
      )}
    </div>
  );
};

export default CareerContentCard;
